"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var abstractComponent_1 = __importDefault(require("./abstractComponent"));
var constants_1 = require("../data/constants");
var Timeout_1 = require("../utils/Timeout");
var scroll_1 = require("../helpers/scroll");
var PageIntro = /** @class */ (function (_super) {
    __extends(PageIntro, _super);
    function PageIntro() {
        var _this = this;
        var _a, _b;
        _this = _super.call(this, constants_1.DATA_PAGE_INTRO) || this;
        _this.timeTextVisible = 3000;
        _this.timeAnimationDuration = 400;
        if (!_this.getElement())
            return _this;
        PageIntro.process = document.querySelectorAll("[".concat(constants_1.DATA_PAGE_INTRO_PROCESS, "]"));
        _this.button = _this.getChildElement("[".concat(constants_1.DATA_PAGE_INTRO_BUTTON, "]"));
        _this.rotatingButton = (_a = _this.button) === null || _a === void 0 ? void 0 : _a.querySelector("[".concat(constants_1.DATA_ROTATING_BUTTON, "]"));
        _this.linetypes = _this.getChildElements("[".concat(constants_1.DATA_PAGE_INTRO_LINETYPE, "]"));
        _this.headline = _this.getChildElement("[".concat(constants_1.DATA_PAGE_INTRO_HEADLINE, "]"));
        _this.blockRight = _this.getChildElement("[".concat(constants_1.DATA_PAGE_INTRO_BLOCK_RIGHT, "]"));
        PageIntro.nextEl = _this.getElement().nextElementSibling;
        if (PageIntro.nextEl)
            PageIntro.nextEl.style.scrollMarginTop = '5rem';
        if (_this.linetypes.length > 0) {
            _this.animateHeadline(0)
                .catch(function (error) { return console.error(error); });
        }
        (_b = _this.button) === null || _b === void 0 ? void 0 : _b.addEventListener('click', function (e) {
            e.preventDefault();
            (0, scroll_1.scrollToDomElement)(PageIntro.nextEl);
        });
        var observerRotatingButton = new IntersectionObserver(_this.callbackRotatingButton, {
            threshold: .3,
        });
        if (_this.rotatingButton)
            observerRotatingButton.observe(_this.rotatingButton);
        return _this;
    }
    PageIntro.prototype.callbackRotatingButton = function (entries) {
        entries === null || entries === void 0 ? void 0 : entries.forEach(function (entry) {
            var target = entry.target;
            if (target.classList.contains(constants_1.DATA_ROTATING))
                entry.target.classList.remove(constants_1.DATA_ROTATING);
            if (!(entry === null || entry === void 0 ? void 0 : entry.isIntersecting))
                return;
            entry.target.classList.add(constants_1.DATA_ROTATING);
        });
    };
    PageIntro.prototype.showLinetypes = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (this.linetypeClassList.contains('hide')) {
                    this.linetypeClassList.remove('hide');
                    this.linetypeClassList.add('show');
                }
                if (this.linetypeClassList.contains('d-none')) {
                    this.linetypeClassList.remove('d-none');
                }
                return [2 /*return*/, 'is-shown'];
            });
        });
    };
    PageIntro.prototype.hideLinetypes = function () {
        this.linetypeClassList.remove('show');
        this.linetypeClassList.add('hide');
    };
    PageIntro.prototype.animateHeadline = function (index) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (index === ((_a = this.linetypes) === null || _a === void 0 ? void 0 : _a.length)) {
                            this.animateHeadline(0)
                                .catch(function (error) { return console.error(error); });
                            return [2 /*return*/];
                        }
                        this.linetypeClassList = (_b = this.linetypes[index]) === null || _b === void 0 ? void 0 : _b.classList;
                        return [4 /*yield*/, this.showLinetypes()
                                .then(function () { return __awaiter(_this, void 0, void 0, function () {
                                var _this = this;
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0: return [4 /*yield*/, (0, Timeout_1.timeout)(this.timeTextVisible + this.timeAnimationDuration)
                                                .then(function () {
                                                var newIndex = index;
                                                newIndex++;
                                                _this.hideLinetypes();
                                                _this.animateHeadline(newIndex)
                                                    .catch(function (error) { return console.error(error); });
                                            })
                                                .catch(function (error) { return console.error(error); })];
                                        case 1:
                                            _a.sent();
                                            return [2 /*return*/];
                                    }
                                });
                            }); })
                                .catch(function (error) { return console.error(error); })];
                    case 1:
                        _c.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    return PageIntro;
}(abstractComponent_1.default));
exports.default = PageIntro;
